"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionRequestStatus = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
var ActionRequestStatus;
(function (ActionRequestStatus) {
    ActionRequestStatus["DRAFT"] = "DRAFT";
    ActionRequestStatus["ACTIVE"] = "ACTIVE";
    ActionRequestStatus["ARCHIVED"] = "ARCHIVED";
    ActionRequestStatus["Draft"] = "DRAFT";
    ActionRequestStatus["Active"] = "ACTIVE";
    ActionRequestStatus["Archived"] = "ARCHIVED";
})(ActionRequestStatus || (exports.ActionRequestStatus = ActionRequestStatus = {}));
